module.exports = __webpack_public_path__ + "static/media/img_kakaoTemp.2953318f.png";